import { MenuAction, MenuActionKeys } from './actions';
import { MenuModes } from '../../typings/menu';

interface MenuState {
	leftMenuIsOpen: boolean;
	menuModes: MenuModes;
}

const initialState: MenuState = {
	leftMenuIsOpen: false
} as MenuState;

function menuManager(
	state: MenuState = initialState,
	action: MenuAction
): MenuState {
	switch (action.type) {
		case MenuActionKeys.REQUEST_OPEN_LEFT_MENU:
			return { ...state, leftMenuIsOpen: true };
		case MenuActionKeys.REQUEST_CLOSE_LEFT_MENU:
			return { ...state, leftMenuIsOpen: false };
		case MenuActionKeys.SET_MENU_MODES:
			return { ...state, menuModes: action.menuModes };
		default:
			return state;
	}
}

export { MenuState, menuManager };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/MenuManager/reducer.ts